import DoneAllIcon from "@mui/icons-material/DoneAll";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import PauseIcon from "@mui/icons-material/Pause";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { CircularProgress } from "@mui/material";
import type { TestAgentV2Status } from "../types/test-agent-2";
import { StatusChip, type StatusEntry } from "./ui/status-chip";

const STATUS_MAP: Partial<Record<TestAgentV2Status, StatusEntry>> = {
  running: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "primary",
  },
  paused: { icon: <PauseIcon sx={{ fontSize: 12 }} />, color: "info" },
  idle: { color: "info" },
  pending: {
    icon: <HourglassBottomIcon sx={{ fontSize: 12 }} />,
    color: "info",
  },
  need_user_input: {
    icon: <QuestionMarkIcon sx={{ fontSize: 12 }} />,
    color: "warning",
  },
  closed: { icon: <DoneAllIcon sx={{ fontSize: 12 }} />, color: "default" },
};

type Props = {
  status: TestAgentV2Status;
  variant?: "outlined" | "filled";
  size?: "small" | "medium";
};

export const GenerateFastStatusChip: React.FC<Props> = ({
  status,
  variant = "outlined",
  size = "medium",
}) => (
  <StatusChip
    status={status}
    statusMap={STATUS_MAP}
    variant={variant}
    size={size}
    sx={{ width: "fit-content" }}
  />
);
